import { FieldHasValue } from 'helpers/Validation';

export const AsLeftResultP630Formula = (formData) => {
    if (FieldHasValue(formData.F1036AltexpectedValveActionOnDemand) && FieldHasValue(formData.F1037AltphysicalValvePositionAfterDemand)) {
        if ((formData.F1036AltexpectedValveActionOnDemand === 'To be Opened' && formData.F1037AltphysicalValvePositionAfterDemand === 'Open')
        || (formData.F1036AltexpectedValveActionOnDemand === 'To be Closed' && formData.F1037AltphysicalValvePositionAfterDemand === 'Closed')) {
            return 'PASS';
        }
        return 'FAIL';
    }
    return '';
};
